
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { HiveLinkedService } from 'app/model/linkedservice/hive.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.hive.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Hive_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Hive_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: HiveLinkedService.MODEL // Linked service redefined
        }
    }
})
export class HiveObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
